<template>
<div class="frame-main" :class="{minSide:stage.setting.loc.sideMode==='min'}">
	<Head  @openNotice="openNotice"></Head>
	<article>
		<transition name="fade" mode="out-in" :duration="{enter:500,leave:200}">
			<router-view></router-view>
		</transition>
		<Notice ref="notice"></Notice>
	</article>
</div>
</template>

<script>
import "vue2-animate/dist/vue2-animate.min.css";

import * as lib from "@/util/lib.js";

import Head from "@/components/frame/Head.vue";
import Notice from "@/view/frame/Notice.vue"

export default {
	name:"BenchMain",
	components:{Head,Notice},
	data () {
		return {
			stage
		}
	},
	methods:{
		openNotice(){
			this.$refs.notice.show()
		}
	},
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/view/frame/Bench.vue